import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { database } from '../config';
import { BASE_URL } from '../url';
import SiteLayout, { PageHero } from './SiteLayout';
import LoadingSpinner from './LoadingSpinner';

function GetAllNews() {
  const [viewAllNews, setViewAllNews] = useState([]);
  const [loggedIn, setLoggedIn] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const history = useNavigate();

  useEffect(() => {
    const checkLoggedIn = onAuthStateChanged(database, (authUser) => {
      setLoggedIn(authUser || null);
      setAuthChecked(true);
    });
    return () => checkLoggedIn();
  }, []);

  useEffect(() => {
    fetch(`${BASE_URL}/getAllNews`)
      .then((response) => response.json())
      .then((data) => setViewAllNews(Array.isArray(data) ? data : []))
      .catch(() => setViewAllNews([]));
  }, []);

  const deleteNews = (newsId) => {
    if (window.confirm('Are you sure you want to delete this News?')) {
      fetch(`${BASE_URL}/deleteNews/${newsId}`, { method: 'DELETE' })
        .then((response) => {
          if (response.ok) {
            alert('News deleted successfully');
            window.location.reload();
          } else {
            alert('Failed to delete the News');
          }
        })
        .catch((error) => console.error('Error:', error));
    }
  };

  const logout = () => {
    signOut(database).then(() => history('/login'));
  };

  return (
    <SiteLayout>
      <main>
        <PageHero eyebrow="Admin" title="Manage news">
          Create, edit, and remove Raising Smiles news posts.
        </PageHero>
        <section className="section-padding admin-section">
          <div className="container">
            {!authChecked && <LoadingSpinner compact />}
            {authChecked && !loggedIn && (
              <div className="empty-state">
                <h2>Login required</h2>
                <p>You are unauthorized to view this page. Please login to continue.</p>
                <Link to="/login" className="btn btn-primary-rs">Login</Link>
              </div>
            )}
            {authChecked && loggedIn && (
              <>
                <div className="admin-toolbar">
                  <Link to="/postNews" className="btn btn-primary-rs">Create New Post</Link>
                  <button type="button" onClick={logout} className="btn btn-outline-rs">Logout</button>
                </div>
                <div className="admin-news-grid">
                  {viewAllNews.map((newsData) => (
                    <article className="admin-news-card" key={newsData._id || newsData.postHeading}>
                      <h2>{newsData.postHeading}</h2>
                      <p className="admin-url">{newsData.imageURL}</p>
                      <p>{newsData.postDetails}</p>
                      <div className="admin-card-actions">
                        <Link to={`/editNews/${newsData._id}`} className="btn btn-primary-rs">Edit</Link>
                        <button type="button" onClick={() => deleteNews(newsData._id)} className="btn btn-danger">Delete</button>
                      </div>
                    </article>
                  ))}
                </div>
              </>
            )}
          </div>
        </section>
      </main>
    </SiteLayout>
  );
}

export default GetAllNews;
